import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles, designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import Car from "../icons/assets/car.svg";
import SVG from "../svg";
import styles from "./holding-image.module.css";
var space = designTokens.customProperties.ds.space;
export var HoldingImage = function(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text, isAvailable = param.isAvailable, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsxs("div", {
        className: cx(styles.holdingImage, className, _define_property({}, styles.holdingImageUnavailable, !isAvailable)),
        children: [
            /*#__PURE__*/ _jsx(SVG, {
                className: styles.icon,
                children: Car,
                fill: "currentColor",
                size: space["8-x"]
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                type: TextStyles.menuTitle,
                children: text
            })
        ]
    });
};
